import { Button } from "../atoms/Button";

type ConfirmDialogProps = {
  readonly isOpen: boolean;
  readonly title: string;
  readonly description: string;
  readonly confirmLabel?: string;
  readonly isConfirming?: boolean;
  readonly onCancel: () => void;
  readonly onConfirm: () => void | Promise<void>;
};

export const ConfirmDialog = ({
  isOpen,
  title,
  description,
  confirmLabel = "Confirm",
  isConfirming = false,
  onCancel,
  onConfirm,
}: ConfirmDialogProps) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
      role="presentation"
      onClick={onCancel}
    >
      <div
        className="w-full max-w-md rounded-xl bg-white p-6 shadow-2xl"
        role="dialog"
        aria-modal="true"
        aria-labelledby="confirm-dialog-title"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 id="confirm-dialog-title" className="text-lg font-semibold text-gray-900">
          {title}
        </h3>
        <p className="mt-2 text-sm text-gray-600">{description}</p>
        <div className="mt-5 flex justify-end gap-2">
          <Button variant="ghost" onClick={onCancel} disabled={isConfirming}>
            Cancel
          </Button>
          <Button onClick={() => void onConfirm()} disabled={isConfirming}>
            {isConfirming ? "Working…" : confirmLabel}
          </Button>
        </div>
      </div>
    </div>
  );
};
